import React from 'react';
import _upperCase from 'lodash/upperCase';
import { useQuery } from '@tanstack/react-query';
import RefDataService from '@app/model/refdata/service/RefDataService';
import { CountryPrefixesQueryKeys } from '@app/model/refdata/service/RefDataQueryKeys';
import { withForm } from '@app/site/_form';
import { FieldErrors } from '@app/site/_form/field/FieldErrors';

const PhoneSubForm = withForm({
	defaultValues: {
		phone: {
			prefix: '',
			number: '',
		},
	},
	props: {
		placeholder: '',
		label: '',
		labelHint: '',
		disabled: false,
	},
	render: function Render({ form, placeholder, label, labelHint = '', disabled }) {
		const { data } = useQuery({
			queryFn: RefDataService.findCountryPhonePrefixes,
			queryKey: CountryPrefixesQueryKeys.all,
		});
		if (!data) {
			return <></>;
		}

		const renderField = () => {
			return <form.AppField name="phone.number"
														children={(field) => <field.TextField disabled={disabled}
																																	hideErrorMessage
																																	placeholder={placeholder}
																																	extraClassName="w-full pl-[7.5rem]" />} />;
		};

		const renderPrefix = () => {
			return <div className="absolute inset-y-0 left-0 flex items-center">
				<label className="sr-only">
					Prefix
				</label>
				<form.AppField name="phone.prefix" children={(field) => <field.SelectField disabled={disabled}
																																									 size="small"
																																									 optionsSize="medium"
																																									 className="h-full rounded-md border-transparent bg-transparent py-1 pl-2 pr-7 ml-1 text-slate-600 focus:border-blue-500 focus:ring-blue-500 text-sm min-w-[115px]"
																																									 hideErrorMessage
																																									 options={data!.filter(o => !!o.abbreviation).map(o => {
																																										 return {
																																											 label: `${_upperCase(o.abbreviation)} (${o.phoneInternationalPrefix})`,
																																											 value: o.phoneInternationalPrefix,
																																											 id: '' + o.id,
																																										 };
																																									 })} />} />
			</div>;
		};

		const phoneFieldMeta = form.getFieldMeta('phone.number');


		return <div>
			<div className="flex justify-between">
				{!!label && <div className="label">{label}</div>}
				{!!labelHint && <span className="text-sm leading-6 text-slate-500">{labelHint}</span>}
			</div>
			<div className="relative mt-0.5 rounded-md">
				{renderPrefix()}
				{renderField()}
			</div>
			{!!phoneFieldMeta && <FieldErrors meta={phoneFieldMeta} />}
		</div>;
	},
});


export default PhoneSubForm;